import store from '@stores';
// 用户自定义配置
let timer: any,
    delay = 300,
    loading: any = null;
var ajaxLoadingConfig = {
    // 展示自定义加载效果以及其他逻辑
    showLoading: function () {
        timer = setTimeout(function () {
            // store.BasicInfoStore.setLoading(true);
            loading = true;
        }, delay);
    },
    showError: function () {
        // store.BasicInfoStore.setLoading(false);
        loading = false;
    },
    // 关闭自定义加载效果以及其他逻辑
    closeLoading: function () {
        if (!timer) return;
        clearTimeout(timer);
        if (loading) {
            // store.BasicInfoStore.setLoading(false);
            loading = false;
        }
    },
    // 某些 Ajax 请求不需要添加加载效果
    ignoreRegex: [
        {
            url: /preload/, // 忽略预加载请求
            method: 'get',
        },
        {
            url: /statistics/, // 忽略统计请求
        },
        {
            url: /user-notification/, // 忽略用户消息通知,
        },
        {
            url: /api.mapbox.com/, // 忽略统计请求
        },
        {
            url: /[personal]+\/+[address]+\/+[search]/, // 忽略统计请求
        },
    ],
};

// 也可以从配置文件读取 ajaxLoadingConfig
// var ajaxLoadingConfig = require('config').ajaxLoadingConfig;

// 以上代码根据具体项目配置，以下代码一般情况下不需要动

export default {
    /**
     * 正在加载的 Ajax 请求个数
     * @type {Number}
     */
    loadingCount: 0,
    /**
     * 忽略某些 Ajax 请求
     * @param  {String} url    Ajax url
     * @param  {String} method HTTP Method
     * @return {Boolean}       是否需要忽略此 Ajax 请求
     */
    isIgnore: function (url: string, method: string) {
        var ignoreRegex = ajaxLoadingConfig.ignoreRegex;
        var len: number = ignoreRegex.length;
        while (len--) {
            if (ignoreRegex[len].url.test(url)) {
                if (!ignoreRegex[len].method || ignoreRegex[len]['method']!.toUpperCase() === method.toUpperCase()) {
                    return true;
                }
            }
        }
        return false;
    },
    /**
     * 显示加载效果
     * @param  {String} url    Ajax url
     * @param  {String} method HTTP Method
     */
    show: function (url: string, method: string) {
        if (this.isIgnore(url, method)) {
            return;
        }
        this.loadingCount++;
        if (this.loadingCount === 1) {
            ajaxLoadingConfig.showLoading && ajaxLoadingConfig.showLoading();
        }
    },
    /**
     * 隐藏加载效果
     * @param  {String} url    Ajax url
     * @param  {String} method HTTP Method
     */
    hide: function (url: string, method: string) {
        if (this.isIgnore(url, method)) {
            return;
        }
        this.loadingCount--;
        if (!this.loadingCount) {
            ajaxLoadingConfig.closeLoading && ajaxLoadingConfig.closeLoading();
        }
    },
    clearLoding() {
        this.loadingCount = 0;
        ajaxLoadingConfig.closeLoading && ajaxLoadingConfig.closeLoading();
    },
    showError() {
        this.clearLoding();
        ajaxLoadingConfig.showError && ajaxLoadingConfig.showError();
    },
};
